import { render } from "./NoteEditor.vue?vue&type=template&id=5d31394f"
import script from "./NoteEditor.vue?vue&type=script&lang=js"
export * from "./NoteEditor.vue?vue&type=script&lang=js"

import "./NoteEditor.vue?vue&type=style&index=0&id=5d31394f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__